import React from 'react';
import OtpLogin from '../components/OtpLogin';

const OtpLoginPage = () => {
  return (
    <div className="min-h-screen">
      <OtpLogin />
    </div>
  );
};

export default OtpLoginPage;
